import React, { useCallback, useState } from 'react'

import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { aggregatePanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
// import { AppStateContext } from '../AppStateContext'
import PiperChartWrapper from './PiperChartWrapper'
import PiperHeader from './PiperHeader'

const Piper = ({ width }) => {

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
                <DataContextProvider>
                    <PiperChartWrapper />
                </DataContextProvider>
        </Panel>
    )
}

export default Piper
